// 基础值
const baseUnit = 37.5;

module.exports = {
  baseUnit: baseUnit,
};
